import React from "react";

import classNames from "classnames";
import { connect } from "react-redux";

import NumberFormat from "react-number-format";
import { Field, FieldArray, reduxForm, formValueSelector } from "redux-form";

import { renderSwitch } from "Utils/renderField/renderField";
import eliminar_icono from "../../Utils/Acciones/Acciones";

const renderField = ({ input, label, type, meta: { touched, error } }) => {
    const invalid = touched && error;
    return (
        <div>
            <input
                {...input}
                placeholder={label}
                type={type}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

const renderFieldSelect = (field) => {
    const invalid = field.meta.touched && field.meta.error;
    return (
        <div>
            <select
                {...field.input}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
            >
                <option value={undefined}></option>
                {field.listado.map((option) => (
                    <option value={option.id} key={option.id}>
                        {option.nombre}
                    </option>
                ))}
            </select>
            {invalid && (
                <div className="invalid-feedback">{field.meta.error}</div>
            )}
        </div>
    );
};

const renderFrases = ({ fields, meta: { touched, error, submitFailed } }) => {
    return (
        <div className="row">
            <div className="col-12 pl-0 pr-0 d-flex justify-content-between border-bottom mb-4">
                <h3>Frases</h3>
                <div>
                    <button
                        type="button"
                        onClick={() => fields.push({})}
                        className="btn btn-primary mb-1"
                    >
                        <em className="fa fa-plus-circle mr-1"></em> Nueva frase
                    </button>
                    <br />
                    {(touched || submitFailed) && error && (
                        <span className="invalid-feedback d-block fnt-14 mb-4">
                            {error}
                        </span>
                    )}
                </div>
            </div>
            <div className="col-12">
                <table className="table table-bordered table-sm">
                    <thead className="">
                        <tr className="bg-light">
                            <th
                                className="text-dark"
                                scope="col"
                                style={{ width: "20%" }}
                            >
                                Tipo
                            </th>
                            <th
                                className="text-dark"
                                scope="col"
                                style={{ width: "20%" }}
                            >
                                Código escenario
                            </th>
                            <th className="text-dark" scope="col">
                                Descripción
                            </th>
                            <th
                                className="text-dark text-center"
                                scope="col"
                                style={{ width: "10%" }}
                            ></th>
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((frase, index) => (
                            <tr key={index}>
                                <td>
                                    <Field
                                        name={`${frase}.tipo`}
                                        type="text"
                                        component={renderField}
                                        label="Ej. 1"
                                    />
                                </td>
                                <td>
                                    <Field
                                        name={`${frase}.codigo`}
                                        type="text"
                                        component={renderField}
                                        label="Ej. 1"
                                    />
                                </td>
                                <td>
                                    <Field
                                        name={`${frase}.descripcion`}
                                        type="text"
                                        component={renderField}
                                        label="Ej. Frase para..."
                                    />
                                </td>
                                <th scope="row" className="text-center">
                                    <img
                                        onClick={() => fields.remove(index)}
                                        className="action-img mt-1"
                                        title="Eliminar"
                                        src={eliminar_icono}
                                        alt="Eliminar"
                                        width="17"
                                    />
                                </th>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// VALIDACIONES
const validate = (values, props) => {
    const errors = {};

    if (!values.nombre) errors.nombre = "Campo requerido";
    if (!values.subdominio) errors.subdominio = "Campo requerido";

    if (values.factura_personalizada === true) {
        if (!values.item_por_factura)
            errors.item_por_factura = "Campo requerido";
    }

    if (!values.pais) errors.pais = "Campo requerido";

    if (values.utiliza_fel === true) {
        if (!values.direccion) errors.direccion = "Campo requerido";
        if (!values.nit) errors.nit = "Campo requerido";
        if (!values.nombre_emisor) errors.nombre_emisor = "Campo requerido";
        if (!values.nombre_comercial)
            errors.nombre_comercial = "Campo requerido";
        if (values.correo_emisor) {
            if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                    values.correo_emisor
                )
            )
                errors.correo_emisor = "Correo electrónico invalido";
        }
        if (!values.tipo_factura || values.tipo_factura == "")
            errors.tipo_factura = "Campo requerido";
        if (!values.usuario_fel) errors.usuario_fel = "Campo requerido";
        if (!values.llave_fel) errors.llave_fel = "Campo requerido";
        if (!values.alias_fel) errors.alias_fel = "Campo requerido";
        if (!values.llave_fel_firma) errors.llave_fel_firma = "Campo requerido";

        if (!values.frases || !values.frases.length) {
            errors.frases = { _error: "Tiene que tener al menos una frase" };
        } else {
            const frasesArrayErrors = [];
            values.frases.forEach((member, memberIndex) => {
                const memberErrors = {};
                if (!member || !member.tipo) {
                    memberErrors.tipo = "Campo requerido";
                    frasesArrayErrors[memberIndex] = memberErrors;
                }
                if (!member || !member.codigo) {
                    memberErrors.codigo = "Campo requerido";
                    frasesArrayErrors[memberIndex] = memberErrors;
                }
            });
            if (frasesArrayErrors.length) {
                errors.frases = frasesArrayErrors;
            }
        }
    }

    return errors;
};

const Form = (props) => {
    // state
    const { utilizaFELValue } = props;
    // bind
    const { handleSubmit } = props;

    const listadoTipoFactura = [
        {
            id: "FACT",
            nombre: "Factura",
        },
        {
            id: "FPEQ",
            nombre: "Factura pequeño contribuyente",
        },
    ];

    return (
        <form onSubmit={handleSubmit} className="row">
            <div className="col-sm-12">
                <h3 className="contenido-1 border-bottom txt-bold black mb-4">
                    Datos de la empresa
                </h3>
            </div>
            <div className="col-md-5 col-sm-12">
                <div className="form-group">
                    <label htmlFor="nombre">Nombre *</label>
                    <Field
                        name="nombre"
                        component={renderField}
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="col-md-1 col-0" />

            <div className="col-md-5 col-sm-12">
                <div className="form-group">
                    <label htmlFor="nombre_comercial">Nombre comercial </label>
                    <Field
                        name="nombre_comercial"
                        component={renderField}
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="col-md-1 col-0" />

            <div className="col-md-5 col-sm-12">
                <div className="form-group">
                    <label htmlFor="subdominio">Subdominio *</label>
                    <Field
                        name="subdominio"
                        component={renderField}
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="col-md-1 col-0" />

            <div className="col-md-5 col-sm-12">
                <div className="form-group">
                    <label htmlFor="direccion">Dirección</label>
                    <Field
                        name="direccion"
                        component={renderField}
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="col-md-1 col-0" />
            {/* <div className="col-md-6 col-sm-12">
                <div className="form-group">
                    <label htmlFor="codigo_postal">Código postal</label>
                    <Field name="codigo_postal" component={renderField} type="text" className="form-control" />
                </div>
            </div> */}
            <div className="col-md-5 col-sm-12">
                <div className="form-group">
                    <label htmlFor="telefono">Teléfono</label>
                    <Field
                        name="telefono"
                        component={renderField}
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="col-md-1 col-0" />

            <div className="col-md-5 col-sm-12">
                <div className="form-group">
                    <label htmlFor="conf_dias_devolucion_cliente">
                        Límite dias de devolución a clientes
                    </label>
                    <Field
                        name="conf_dias_devolucion_cliente"
                        component={renderField}
                        type="text"
                    />
                </div>
            </div>
            <div className="col-md-1 col-0" />
            {/* <div className="col-md-6 col-sm-12">
                <div className="form-group">
                    <label htmlFor="pais">País *</label>
                    <Field
                        name="pais"
                        component="select"
                        className="form-control"
                    >
                        {listadoPaises.map((paisOption) => (
                            <option value={paisOption.id} key={paisOption.id}>
                                {paisOption.nombre}
                            </option>
                        ))}
                    </Field>
                </div>
            </div> */}

            {/* <div className="col-sm-12">
                <div className="form-group">
                    <label htmlFor="conf_tienda_online">
                        Habilitar tienda online &nbsp;
                    </label>
                    <Field
                        name="conf_tienda_online"
                        component="input"
                        type="checkbox"
                    />
                </div>
            </div>
            {conf_tienda_onlineValue && (
                <div className="col-12">
                    <div className="form-group ml-2">
                        <label htmlFor="categorias">
                            Seleccione la categoría
                        </label>
                    </div>
                    <TreeCategoria
                        categorias={categorias}
                        asignarCategoria={asignarCategoria}
                        setCategoriasExpanded={setCategoriasExpanded}
                        categorias_seleccionados={categorias_seleccionados}
                        categorias_expanded={categorias_expanded}
                    />
                </div>
            )} */}

            <div className="col-12 col-md-6 mb-2">
                <div className="form-group">
                    <label htmlFor="utiliza_fel">Utiliza FEL </label>
                    <div className="d-flex">
                        <label className="mr-2">No</label>
                        <Field
                            name="utiliza_fel"
                            component={renderSwitch}
                            type="text"
                            className="form-control"
                        />
                        <label className="ml-2">Si</label>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label htmlFor="bloqueada">Bloquear empresa </label>
                    <div className="d-flex">
                        <label className="mr-2">No</label>
                        <Field
                            name="bloqueada"
                            component={renderSwitch}
                            type="text"
                            className="form-control"
                        />
                        <label className="ml-2">Si</label>
                    </div>
                </div>
            </div>

            {utilizaFELValue && (
                <div className="w-100 mb border-datos-feel">
                    <div className="row">
                        <div className="col-12 mt-4">
                            <div className="form-group">
                                <FieldArray
                                    name="frases"
                                    component={renderFrases}
                                />
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
            )}
            {/* <div className="col-sm-12">
                <div className="form-group">
                    <label htmlFor="factura_personalizada">
                        Factura personalizada &nbsp;
                    </label>
                    <Field
                        name="factura_personalizada"
                        component="input"
                        type="checkbox"
                    />
                </div>
          
                {print_state.flag && <PrintComponent />}
                {facturaPersonalizadaValue ? (
                    <div className="row col-12 pt-1 content-formato-factura">
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label htmlFor="item_por_factura">
                                    Productos por factura
                                </label>
                                <Field
                                    name="item_por_factura"
                                    component={renderField}
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label htmlFor="ubicacion_total">
                                    Ubicación del total
                                </label>
                                <Field
                                    name="ubicacion_total"
                                    component="select"
                                    className="form-control"
                                >
                                    {ubicacionesTotal.map((paisOption) => (
                                        <option
                                            value={paisOption.id}
                                            key={paisOption.id}
                                        >
                                            {paisOption.nombre}
                                        </option>
                                    ))}
                                </Field>
                            </div>
                        </div>
                        <div className="col-12">
                            <h2>Formato factura</h2>
                            <div className="col-12">
                                <button
                                    type="button"
                                    className="btn btn-secondary mr-2"
                                    onClick={() =>
                                        cambioTipoFormatoFactura("normal")
                                    }
                                >
                                    Formato Normal
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary ml-2"
                                    onClick={() =>
                                        cambioTipoFormatoFactura("fel")
                                    }
                                    disabled={!utilizaFELValue}
                                >
                                    Formato FEL
                                </button>
                            </div>
                            <LiveProvider
                                className="d-flex flex-column"
                                code={formato_factura}
                                noInline={false}
                                scope={{
                                    ...datos_ejemplo,
                                    RenderNumber,
                                    RenderCurrency,
                                    RenderDateTime,
                                    icons,
                                    getDateObject,
                                }}
                            >
                                <LiveEditor
                                    className="live-editor"
                                    style={{ flex: 1 }}
                                    onChange={(val) => {
                                        cambioFormatoFactura(val);
                                    }}
                                />
                                <div className="mt1 mb1 content-row-end-center">
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            print("facturaVenta");
                                        }}
                                        className="btn btn-primary mt-lg"
                                        type={"button"}
                                    >
                                        <em className="fa fa-print" /> Imprimir
                                    </button>
                                </div>
                                <div style={{ flex: 1 }} className="d-table">
                                    <PrintContainer
                                        name="facturaVenta"
                                        className="impresion-venta d-table w-100"
                                    >
                                        <LivePreview className="d-table w-100" />
                                        <LivePreview className="salto-pagina d-table w-100" />
                                    </PrintContainer>
                                </div>
                                <LiveError />
                            </LiveProvider>
                        </div>
                    </div>
                ) : null}
            </div> */}
            <div className="col-sm-12">
                <button type="submit" className="btn btn-primary">
                    Actualizar datos Empresa
                </button>
            </div>
        </form>
    );
};

let EmpresaForm = reduxForm({
    // a unique name for the form
    form: "EmpresaEditar",
    validate,
})(Form);

//  Decorador para leer los valores del form
const selector = formValueSelector("EmpresaEditar");

EmpresaForm = connect((state) => {
    const facturaPersonalizadaValue = selector(state, "factura_personalizada");
    const utilizaFELValue = selector(state, "utiliza_fel");
    const conf_tienda_onlineValue = selector(state, "conf_tienda_online");
    return {
        facturaPersonalizadaValue,
        utilizaFELValue,
        conf_tienda_onlineValue,
    };
})(EmpresaForm);

export default EmpresaForm;
